import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { t } from '../../translations/getTranslation';
const EnrichedTransactionContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.greyNinetyEight};
  padding: ${({ theme: { spacing } }) => `0 ${spacing.base}px`};
  padding: ${({ theme: { spacing } }) => `${spacing.medium}px ${spacing.base}px 0`};

  & > :not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};

    @media ${query.greaterThanMedium} {
      border-bottom: unset;
    }
  }

  @media ${query.greaterThanMedium} {
    padding: 0 ${({ theme }) => theme.spacing.large}px;
    padding-top: ${({ theme }) => theme.spacing.large}px;
    padding-bottom: ${({ theme }) => theme.spacing.medium}px;
  }
`;
const EnrichedDataContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${({ theme: { spacing } }) => `0 ${spacing.medium}px 0`};

  @media ${query.greaterThanMedium} {
    flex-direction: row;
  }

  &:first-child {
    padding-top: 0;
  }
`;
const EnrichedDataName = styled.div `
  @media ${query.greaterThanMedium} {
    flex: 0 0 172px;
    margin-right: 55px;
  }
`;
const EnrichedDataValue = styled.div `
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;
const EnrichedTransactionSection = ({ address, purchaseLocation, referenceNumber }) => {
    return (_jsxs(EnrichedTransactionContainer, Object.assign({ "data-testid": "enriched-txn-container", "data-cy": "enriched-transaction-section" }, { children: [referenceNumber && (_jsxs(EnrichedDataContainer, { children: [_jsx(EnrichedDataName, { children: t('cantVerify.referenceNumber') }), _jsx(EnrichedDataValue, { children: referenceNumber })] })), purchaseLocation && (_jsxs(EnrichedDataContainer, { children: [_jsx(EnrichedDataName, { children: t('cantVerify.purchaseLocation') }), _jsx(EnrichedDataValue, { children: purchaseLocation })] })), address && (_jsxs(EnrichedDataContainer, { children: [_jsx(EnrichedDataName, { children: t('cantVerify.address') }), _jsx(EnrichedDataValue, { children: address })] }))] })));
};
export default EnrichedTransactionSection;
//# sourceMappingURL=EnrichedSection.js.map